import React, { useState } from "react";
import FormTodo from "./FormTodo";
import TodoList from "./TodoList";

const App = () => {
  const [lists, setList] = useState([]);

  const addTodo = (todo) => {
    const todos = [...lists, { todo }];
    setList(todos);
  };

  const deleteTodo = (index) => {
    const todos = [...lists];
    todos.splice(index, 1);
    setList(todos);
  };

  const completeTodo = (index) => {
    const todos = [...lists];
    todos[index].isCompleted = true;
    setList(todos);
    console.log(todos);
  };

  return (
    <div className="flex w-full h-screen justify-center items-center">
      <div className="max-w-sm bg-green-200 w-full p-4 rounded-sm shadow-md">
        <h1 className="font-bold text-center mb-2 text-xl">To-Do List</h1>
        <FormTodo addTodo={addTodo} />
        <TodoList
          lists={lists}
          deleteTodo={deleteTodo}
          completeTodo={completeTodo}
        />
      </div>
    </div>
  );
};

export default App;
